import React from "react";
import { useForm } from "react-hook-form";
import Input from "../../Input";
import * as S from "./styles";
export var SubscribeInput = function SubscribeInput(_ref) {
  var e = _ref.onSubscribeSubmit;

  var _useForm = useForm(),
      r = _useForm.register,
      t = _useForm.handleSubmit,
      s = _useForm.errors,
      a = _useForm.reset;

  return React.createElement(S.Form, {
    onSubmit: t(function (r) {
      e(r), a();
    }),
    id: "newsletterSubscriptionForm"
  }, React.createElement(Input, {
    id: "subscribeEmail",
    name: "subscribeEmail",
    "aria-label": "Email address",
    placeholder: "Email address",
    type: "email",
    ref: r({
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        message: "Invalid email address"
      },
      required: "Please enter your email address"
    }),
    error: s.subscribeEmail && s.subscribeEmail.message,
    footerStyle: !0
  }), React.createElement(S.SubmitButton, {
    type: "submit"
  }, "Sign up"));
};
export default SubscribeInput;